import AsyncComponent from '../../AsyncComponent';

const PaymentStep = () => (
	<AsyncComponent load={() => import(/* webpackChunkName: "AsyncAdyen" */'../../payments/adyen/Adyen')} />
);

export default PaymentStep;



// WEBPACK FOOTER //
// ./components/blocks/raffleForm/PaymentStep.js